// extracted by mini-css-extract-plugin
export default {"Container":"OfferWithComments_Container__zfjnw"};